import Conversion from "./Conversion";

export default class JobFeedback {
    submitted = false;
    submittedFull = false;
    rating = 0;
    message = '';
    loading = false;

    constructor() {
    }
}